
export function slideDown(el, duration = 300) {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;

    let height = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = 0;

    el.offsetHeight; 

    el.style.transition = `height ${duration}ms ease`;
    el.style.height = height + 'px';

    window.setTimeout(() => {
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('transition');
    }, duration);
}

export function slideUp(el, duration = 300) {
    el.style.height = el.offsetHeight + 'px';
    el.style.overflow = 'hidden';
    el.offsetHeight;

    el.style.transition = `height ${duration}ms ease`;
    el.style.height = 0;

    window.setTimeout(() => {
        el.style.display = 'none';
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('transition');
    }, duration);
}

export function slideToggle(el, duration = 300) {
    if (window.getComputedStyle(el).display === 'none') {
        return slideDown(el, duration);
    }
    return slideUp(el, duration);
}
